import React from 'react';
import PropTypes from 'prop-types';
class ProgressBar extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'ProgressBar';
    }
    render() {
    	var percent = 0;
    		if(this.props.percent)
    			percent = this.props.percent;
    	percent = percent * 100;
        return (
			<div className="progress progress-striped m-md">
				<div className="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{width: percent + "%"}}>
					{percent.toFixed(2)}%
				</div>
			</div>
        );
    }
}

ProgressBar.propTypes = {
	percent : PropTypes.number
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/browser/components/ui/progressBar.js